import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const SemiCircleShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 446.1 215.2",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M223.1 0C102.9-.1 4.2 95.1 0 215.2h446.1C441.9 95.1 343.3-.1 223.1 0z"
    })
  });
};

export { SemiCircleShape };
//# sourceMappingURL=SemiCircleShape.js.map
